var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretDown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.7071 12.7071L16.7071 22.7071C16.6142 22.8001 16.5039 22.8738 16.3825 22.9241C16.2611 22.9745 16.131 23.0004 15.9996 23.0004C15.8682 23.0004 15.738 22.9745 15.6166 22.9241C15.4952 22.8738 15.385 22.8001 15.2921 22.7071L5.29208 12.7071C5.10444 12.5194 4.99902 12.2649 4.99902 11.9996C4.99902 11.7342 5.10444 11.4797 5.29208 11.2921C5.47972 11.1044 5.73422 10.999 5.99958 10.999C6.26494 10.999 6.51944 11.1044 6.70708 11.2921L15.9996 20.5858L25.2921 11.2921C25.385 11.1992 25.4953 11.1255 25.6167 11.0752C25.7381 11.0249 25.8682 10.999 25.9996 10.999C26.131 10.999 26.2611 11.0249 26.3825 11.0752C26.5039 11.1255 26.6142 11.1992 26.7071 11.2921C26.8 11.385 26.8737 11.4953 26.924 11.6167C26.9743 11.7381 27.0001 11.8682 27.0001 11.9996C27.0001 12.131 26.9743 12.2611 26.924 12.3825C26.8737 12.5039 26.8 12.6142 26.7071 12.7071Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.28e36920e99dd03a5db532ad604b4a1c.svg";
export { ForwardRef as ReactComponent };